import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import { useParams, withRouter } from 'react-router';
import AspectService from 'app/admin/aspect/service/AspectService';
import AspectEditService from 'app/admin/aspect/service/AspectEditService';
import AspectAnalysisField from '../component/AspectAnalysisField';
import LabMeasurementReaderEditService from '../service/LabMeasurementReaderEditService';
import LabConnectionService from 'app/admin/labConnection/service/LabConnectionService';
import StorageLabMeasurementReaderService from '../service/StorageLabMeasurementReaderService';
import { useLabMeasurementReader } from '../component/LabMeasurementReaderProvider';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const prettyType = (t) => {
	const map = {
		Variable: 'VARIABLE',
		ComponentMassFrac: 'MASSFRAC',
		ComponentMassFlow: 'MASSFLOW',
		DistillationCurve: 'DISTILLATIONCURVE'
	};

	const s = (t != null ? String(t) : '');
	if (map[s]) return map[s];

	if (s.indexOf('Component') === 0) return s.replace('Component', '').toUpperCase();
	return s ? s.toUpperCase() : 'UNKNOWN';
};

const handleFieldsFromAspect = (dto, field) => {
	return new Promise((resolve, reject) => {
		const fieldIndex = parseInt(field.name.replace(/\D/g, ''), 10);

		if (!dto || !Array.isArray(dto.fields) || !dto.fields[fieldIndex] || !dto.aspect) return resolve([]);

		AspectEditService.getData(dto.aspect).then(resp => {
			let values = [];

			const inputs = Array.isArray(resp?.inputAttributes) ? resp.inputAttributes : [];
			for (let i = 0; i < inputs.length; i += 1) {
				const t = prettyType(inputs[i]?.type);
				values.push({ label: 'INPUT.' /*+ t + '.'*/ + inputs[i].name, value: inputs[i].name });
			}

			const outputs = Array.isArray(resp?.outputAttributes) ? resp.outputAttributes : [];
			for (let i = 0; i < outputs.length; i += 1) {
				const t = prettyType(outputs[i]?.type);
				values.push({ label: 'OUTPUT.' /*+ t + '.'*/ + outputs[i].name, value: outputs[i].name });
			}

			resolve(values);
		}).catch(e => reject(e));
	});
};

const config = data => {
	const storageLabMeasurementReaderService = new StorageLabMeasurementReaderService();

	return {
		key: 'labMeasurementReaderEditForm',
		text: 'Lab Measurement Reader',
		topic: 'labMeasurementReader',
		service: LabMeasurementReaderEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'fields' }];
		},
		defaultValue: () => LabMeasurementReaderEditService.create(),
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'labConnection',
					component: EditFormSelectField,
					items: () => LabConnectionService.getListSelection()
				},
				{
					key: 'location',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'labConnection',
					items: labConnectionId => storageLabMeasurementReaderService.getLocations(labConnectionId)
				},
				{
					key: 'aspect',
					component: EditFormSelectField,
					required: true,
					items: () => AspectService.getListSelection()
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'fields',
					tab: 'fields',
					component: EditFormGridComponent,
					orderable: true,
					defaultValue: {
						orderIndex: null
					},
					fields: [
						{
							key: 'type',
							component: EditFormSelectField,
							type: 'enum',
							items: [
								{ label: 'Variable', value: 'Variable' },
								{ label: 'Mass Frac', value: 'ComponentMassFrac' },
								{ label: 'Mass Flow', value: 'ComponentMassFlow' },
								{ label: 'DistillationCurve', value: 'DistillationCurve' }
							]
							// items: (dto, field) => handleSomething(dto || initData, field),
						},
						{
							key: 'category',
							component: EditFormSelectField,
							type: 'enum',
							items: [
								{ label: 'Input', value: 'Input' },
								{ label: 'Output', value: 'Output' }
							]
						},
						// {
						// 	key: 'name',
						// 	component: EditFormTextField,
						// 	required: true,
						// 	dependsOn: 'type',
						// 	visibleIf: type => (type && type === 'Variable')
						// },
						{
							key: 'name',
							component: EditFormSelectField,
							type: 'enum',
							required: true,
							// dependsOn: 'type',
							// items: () => data.labMeasurementProvider.getMassOptionList(),
							items: (dto, field) => handleFieldsFromAspect(dto || initData, field),
							// visibleIf: type => (type && type !== 'Variable')
						},
						{
							key: 'uom',
							component: EditFormTextField,
							dependsOn: 'type',
							// visibleIf: type => type === 'Variable'
						},
						{
							key: 'sampling_point',
							component: EditFormSelectField,
							type: 'enum',
							dependsOn: ['^labConnection', '^location'],
							filterKey: ['^labConnection', '^location'],
							itemsParameterIsDto: true,
							items: (dto, field) => storageLabMeasurementReaderService.getSamplingPoint(dto, field) || []
						},
						{
							key: 'analysis',
							component: EditFormSelectField,
							type: 'enum',
							dependsOn: ['^labConnection', 'sampling_point'],
							filterKey: ['^labConnection', 'sampling_point'],
							itemsParameterIsDto: true,
							items: (dto, field) => storageLabMeasurementReaderService.getAnalysisOptionList(dto, field) || []
						},
						// {
						// 	key: 'value',
						// 	component: EditFormSelectField,
						// 	type: 'enum',
						// 	dependsOn: 'type',
						// 	items: (dto, field) => storageLabMeasurementReaderService.getAnalysisInfo(dto, field) || [],
						// 	visibleIf: type => (type && type === 'Variable')
						// },
						{
							key: 'component',
							component: EditFormSelectField,
							type: 'enum',
							dependsOn: ['type', 'sampling_point', 'analysis'],
							filterKey: ['^labConnection', 'sampling_point', 'analysis'],
							itemsParameterIsDto: true,
							items: (dto, field) => storageLabMeasurementReaderService.getAnalysisInfo(dto, field) || [],
							visibleIf: (dep) => {
								const type = Array.isArray(dep) ? dep[0] : dep;
								return type === 'Variable';
							}
						},
						{
							key: 'component_map',
							component: AspectAnalysisField,
							// loadValueFrom: 'component_map',
							dependsOn: 'type',
							storageService: storageLabMeasurementReaderService,
							visibleIf: type => (type && type !== 'Variable')
						}
					]
				}
			];
			return fields;
		}
	};
};

function LabMeasurementReaderEditForm() {
	const { id, tabKey } = useParams();
	const labMeasurementProvider = useLabMeasurementReader();
	// const { setAspectId } = useLabMeasurementReader();

	const myConfig = config({ id, labMeasurementProvider });

	return <EditFormPage config={myConfig} startTabValue={tabKey} onWatch={(d) => labMeasurementProvider.setAspectId(d.aspect)} />;
}

export default withRouter(LabMeasurementReaderEditForm);
